import {NavigationProps} from "../constants/Props";
import {observer} from "mobx-react";
import Screen from "../components/Screen";
import Box from "../components/Box";
import {isMobile} from "react-device-detect";
import Title from "../components/Title";
import {toI18N} from "../utils/I18n";
import textStyles from "../css/Text.module.css";
import * as Analytics from "../utils/Analytics";
import React, {useCallback, useEffect, useRef} from "react";
import {IGroupStore} from "../stores/GroupStore";
import Text from "../components/Text";
import Image from "../components/Image";
import {ModalAction} from "../components/ModalDialog";
import Modals, {ModalsRefProps} from "../components/Modals";
import isUrl from "is-url";
import imageStyles from "../css/Image.module.css";
import {usePrevious} from "../utils/HooksHelper";

interface Props extends NavigationProps {
    store: IGroupStore,
}

function AddWelcomePostScreen(props: Props) {
    const {
        onBack,
        onNext,
        store: {
            setWelcomePostText,
            welcomePostText,
            welcomePostImages,
            addLocalWelcomePostImage,
            addUrlWelcomePostImage,
            removeWelcomePostImage
        },
        isActive,
    } = props;

    const prevIsActive = usePrevious(isActive);
    useEffect(() => {
        if (!prevIsActive && isActive) {
            Analytics.logEvent(Analytics.events.land_on_add_welcome_post_page);
        }
    });

    const modalsRef = useRef<ModalsRefProps>(null);

    const handleOnChange = useCallback((e) => {
        if (e.target) {
            setWelcomePostText(e.target.value)
        }
    }, [setWelcomePostText]);

    const onOpenImageModal = useCallback(
        (e) => {

            const newOptions = new Array<ModalAction>(
                {
                    value: toI18N('image_picker_select_local_file'),
                    isFileInput: true,
                    onChange: addLocalWelcomePostImage
                },
                {
                    value: toI18N('image_picker_select_image_url'), keepModalShown: true, onClick: () => {
                        modalsRef && modalsRef.current && modalsRef.current.showTextInputModal(addUrlWelcomePostImage);
                    }
                }
            );


            // image && newOptions.push({value: toI18N('image_picker_remove_image'), onClick: removeImage});

            newOptions.push({value: toI18N('general_cancel')});

            modalsRef && modalsRef.current && modalsRef.current.showActionsModal(newOptions);

        },
        [addLocalWelcomePostImage, addUrlWelcomePostImage],
    );

    return (
        <Screen title={"add_welcome_post_screen_header_title"} disabledKeyDown
            subtitle={"add_welcome_post_screen_header_subtitle"} onBack={onBack} onNext={onNext}>
            <Box sideMargin center bottomMargin={20} topMargin={isMobile ? 45 : 100}> <Title lg shrink
                title={toI18N('welcome_post_title')}/> </Box>
            <Box sideMargin bottomMargin={7}>
                <Text
                    size={16}>{toI18N("welcome_post_subtitle")}</Text>
            </Box>
            <Box sideMargin>
                <textarea
                    value={welcomePostText}
                    onChange={handleOnChange}
                    id={`welcome_post_textarea`}
                    inputMode={"text"}
                    placeholder={toI18N('welcome_post_textarea_placeholder')}
                    cols={40}
                    rows={3}/>
            </Box>
            <Box sideMargin topMargin={4}>
                <label
                    className={textStyles.hint}>{toI18N('welcome_post_hint')}</label>
            </Box>
            <Box sideMargin topMargin={-4}>
                {welcomePostImages?.map((image, index) => <Image onError={() => {
                }} isPreview={false} onClick={() => {
                    const newOptions = new Array<ModalAction>(
                        {
                            value: toI18N('welcome_post_remove_image'), onClick: () => {
                                removeWelcomePostImage(index);
                            }
                        }
                    );
                    newOptions.push({value: toI18N('general_cancel')});

                    modalsRef && modalsRef.current && modalsRef.current.showActionsModal(newOptions);
                }}
                    src={image ? image.path : undefined}
                    onLoad={image ? image.setIsLoaded : undefined}
                    objectFit={"cover"}
                    className={imageStyles.welcomePostImage} height={100}
                    width={100}/>)}
                {welcomePostImages.length < 5 ? <Image onError={() => {
                }} isPreview={false} onClick={onOpenImageModal}
                    src={undefined}
                    onLoad={undefined}
                    className={imageStyles.welcomePostImage} height={100}
                    width={100}/> : null}
            </Box>
            <Box grow/>
            <Modals
                id={'group-setting-screen'}
                modalTextInputValidation={isUrl}
                ref={modalsRef}/>
        </Screen>
    )
}

export default observer(AddWelcomePostScreen);
